import lsClient from "@/services/ls-client";
import {User} from "@/types/models";
import {create} from "zustand";
import {devtools, persist} from "zustand/middleware";
import {immer} from "zustand/middleware/immer";

const initState = {
  token: null as null | string,
  user: null as null | User,
  doingLogout: false,
  clearData: false
};
type State = typeof initState;

export const useAuthStore = create<State>()(
  persist(
    immer(
      devtools(
        () => initState,
        {enabled: true, name: "auth-store"}
      )
    ),
    {name: "auth-store"}
  )
);

export function setAuth(token: string, user: User) {
  return useAuthStore.setState(state => {
    state.token = token;
    state.user = user;
  }, false, {type: "auth-store/setAuth", token, user});
}

export function setClearData(set: boolean) {
  return useAuthStore.setState(state => {
    state.clearData = set;
  }, false, {type: "auth-store/setClearData", set});
}

export function setToken(token: string) {
  return useAuthStore.setState(state => {
    state.token = token;
  }, false, {type: "auth-store/setToken", token});
}

export function updateUser(user: User) {
  return useAuthStore.setState(state => {
    state.user = user;
  }, false, {type: "auth-store/updateUser", user});
}

export function resetAuthStore() {
  return useAuthStore.setState(() => initState, false, {type: "auth-store/clearAuth"});
}

export function doingLogout(set: boolean, source = "") {
  return useAuthStore.setState(state => {
    state.doingLogout = set;
  }, false, {type: "auth-store/doingLogout", source});
}

export function clearAuthState() {
  lsClient.disconnect();
  return useAuthStore.setState(() => initState);
}
